// material-ui
import { Typography } from '@mui/material';
import { useSelector } from 'react-redux';

// project imports
import NavGroup from './NavGroup';
import menuItem from 'menu-items';
import { isAdmin } from 'utils/common';

// ==============================|| SIDEBAR MENU LIST ||============================== //
const MenuList = () => {
  const currentUser = useSelector((state) => state.account.user);
  const userIsAdmin = isAdmin();
  const bizRole = userIsAdmin ? 'admin' : currentUser?.biz_role;

  const canShowMenu = (child) => {
    if (child.isAdmin && !userIsAdmin) {
      return false;
    }
    if (!child.roles || child.roles.length === 0) {
      return true;
    }
    return child.roles.includes(bizRole);
  };

  return (
    <>
      {menuItem.items.map((item) => {
        if (item.type !== 'group') {
          return (
            <Typography key={item.id} variant="h6" color="error" align="center">
              Menu Items Error
            </Typography>
          );
        }

        const filteredChildren = item.children.filter(canShowMenu);

        if (filteredChildren.length === 0) {
          return null;
        }

        return <NavGroup key={item.id} item={{ ...item, children: filteredChildren }} />;
      })}
    </>
  );
};

export default MenuList;
